(function() {
  var isCinematic = document.getElementById('MainContent')?.dataset?.cinematic === 'true';
  if (!isCinematic) return;

  var revealElements = document.querySelectorAll('[data-hc-reveal]');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hc-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  revealElements.forEach(function(el) { observer.observe(el); });

  document.querySelectorAll('[data-hc-mask]').forEach(function(el) {
    observer.observe(el);
  });

  var kenBurnsTriggers = document.querySelectorAll('[data-hc-kenburns-trigger]');
  var kenBurnsObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hc-kenburns-active');
        kenBurnsObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  kenBurnsTriggers.forEach(function(el) { kenBurnsObserver.observe(el); });
})();
